import React, {
  forwardRef,
  useImperativeHandle,
  useMemo,
  useState
} from 'react'

import {
  Botao,
  FormUnform,
  InputUnform,
  ModalBaseProps,
  Spacer
} from 'src/componentes'
import { ModalBase } from 'src/componentes/modal-base'
import { GradeCurricularSituacao } from 'src/tipos'

import { Corpo, ContainerBotoes } from '../../styles'
import { createSchema } from './schema'
// import { createSchema } from './schema'
import { ModalIncluirDisciplinaCertificacaoRef } from './tipos'

const ModalIncluir: React.ForwardRefRenderFunction<
  ModalIncluirDisciplinaCertificacaoRef,
  ModalBaseProps
> = ({ backdrop, acaoPrimaria }, ref) => {
  const [aberta, definirAberta] = useState(false)
  const [pronto, definirPronto] = useState(false)

  const fechar = () => {
    definirPronto(false)
    definirAberta(false)
  }

  const abrir = () => {
    definirAberta(true)
    definirPronto(true)
  }

  useImperativeHandle<
    ModalIncluirDisciplinaCertificacaoRef,
    ModalIncluirDisciplinaCertificacaoRef
  >(ref, () => ({
    fechar,
    abrir
  }))

  const acaoSucesso = async (dados: any) => {
    acaoPrimaria(dados)
    fechar()
  }

  const dadosIniciais = useMemo(() => {
    return {
      situacaoGrade: GradeCurricularSituacao[GradeCurricularSituacao.Ativo],
      tipoModulo: 'Fixo'
    }
  }, [])

  return (
    <>
      <ModalBase aberta={aberta} backdrop={backdrop}>
        <Corpo style={{ width: '500px' }}>
          <h5>Incluir Disciplina</h5>
          <Spacer padding="10px 0px" />
          {pronto && (
            <FormUnform
              schema={createSchema}
              // dadosIniciais={dadosIniciais}
              acaoSucesso={acaoSucesso}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: '15px'
                }}
              >
                <div style={{ width: '100%' }}>
                  <InputUnform
                    name="nome"
                    label="Nome da Disciplina"
                    obrigatorio
                    maxLength={200}
                  />
                  <InputUnform
                    name="cargaHoraria"
                    label="Carga Horária"
                    obrigatorio
                    maxLength={200}
                  />
                </div>
              </div>
              <Spacer padding="10px 0px" />
              <ContainerBotoes>
                <Botao
                  type="button"
                  id="btn-cancelar"
                  texto="Cancelar"
                  tema="Secundario"
                  onClick={() => {
                    fechar()
                  }}
                />
                <Botao id="btn-salvar" texto="Salvar" type="submit" />
              </ContainerBotoes>
            </FormUnform>
          )}
        </Corpo>
      </ModalBase>
    </>
  )
}
export const ModalIncluirDisciplina = forwardRef(ModalIncluir)
